<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Herr+Von+Muellerhoff&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Yellowtail&display=swap');

.signature-input {
  padding: 0px 15px 5px 15px;
  font-size: 22pt;
  font-family: 'Yellowtail', cursive;
  height: auto !important;
}


@media only screen and (max-width: 600px) {
  .signature-input {
    font-size: 20pt;
    font-family: 'Yellowtail', cursive;
  }
}

@media only screen and (max-width: 480px) {
  .signature-input {
    font-size: 14pt;
    font-family: 'Yellowtail', cursive;
  }
}

/*label {*/
/*    font-size: 1.5em;*/
/*}*/

.toggle {
  margin-bottom: 15px;
  margin-right: 10px;
}
</style>

<template>
  <div class="uk-grid">
    <template v-if="signature">
      <div class="uk-width-medium-1-1 uk-width-small-1-1">
        <h2 class="signature-input uk-margin-top uk-margin-bottom">{{ signature.name }} </h2>
        <p>
          User #{{signature.user_id}} with current name: {{ signature.user.full_name }}, <br>
          Signed using the name: {{ signature.name }}<br>
          at {{ signature.created_at | moment('MM/DD/YYYY HH:mm a') }}
          <span v-if="permissions.processor"></span>from IP address {{ signature.ip_address }}
        </p>
      </div>
    </template>
    <template v-else>
      <div class="uk-width-medium-1-1 uk-width-small-1-1" v-if="completed">
        <h2 class="signature-input uk-margin-top uk-margin-bottom">{{ name }} </h2>
      </div>
      <div class="uk-width-medium-1-1 uk-width-small-1-1" v-else>
        <div>
          <h4 aria-label="name"><i>{{ name }}</i></h4>
        </div>
        <div class="uk-margin-top uk-flex uk-flex-column">
          <div class="uk-flex uk-flex-row">
            <toggle-button :color="color" :value="signatureMatches" :sync="true" :disabled="true" class="toggle"/>
            <span v-if="signatureMatches">{{ __('tenant.i_agree') }}</span>
            <span v-else>{{ __('tenant.type_name') }}</span>
          </div>

        </div>
        <form autocomplete="off" @submit.prevent="() => {}">
          <input autocomplete="off" ref="signature-input" :value="signatureText"
                 aria-label="name"
                 @input="onInput"
                 @keypress="onInputChanged" type="text" class="signature-input">
        </form>
      </div>
    </template>

  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: "SignatureBox",
  props: {
    name: {
      type: String,
      default: '',
    },
    isSigned: {
      type: Boolean,
      default: false,
    },
    userKey: {
      type: String,
      default: '',
    },
    typeKey: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: '#75c791',
    },
    completed: {
      type: Boolean,
      deafult: false
    },
    userType: {
      type: String,
      default: 'applicant'
    }
  },
  data() {
    return {
      signatureText: '',
    }
  },
  watch: {
    isSigned(newValue) {
      if(!!newValue) {
        this.signatureText = this.name;
      } else {
        this.signatureText = '';
      }
    }
  },
  computed: {
    signature() {
      let signatures = _.filter(this.signatures, signature => {
        return signature && signature.hasOwnProperty('key') && signature.key == this.typeKey;
      });

      if(signatures.length == 0) return null;

      if(this.userType == 'applicant') {
        return _.first(_.filter(signatures, sig => {
          for(let i in sig.users) {
            if(sig.users[i].id == this.userKey) {
              return true;
            }
          }
          return false;
        }))
      }else {
        return _.first(_.filter(signatures, sig => {
          for(let i in sig.household_members) {
            if(sig.household_members[i].id == this.userKey) {
              return true;
            }
          }
          return false;
        }))
      }
      return null;
    },
    signatureMatches() {
      return this.cleanInput(this.signatureText) === this.cleanInput(this.name) && this.cleanInput(this.name);
    },
    ...mapState('Application', {
      application: state => state.application,
      signatures: state => state.signatures,
    }),
    ...mapState('App', {
      permissions: state => state.permissions,
    })
  },
  mounted() {
    if(this.isSigned) {
      this.signatureText = this.name;
    }
    if (this.$refs['signature-input'])
    {
      this.$refs['signature-input'].onpaste = e => {
        e.preventDefault();
      }
    }
  },
  methods: {
    cleanInput(input) {
      return input.replace(/[^a-zA-Z0-9]/g, "").toLowerCase();
    },
    reset() {
      this.signatureText = ''
    },

    onInput($event) {
      this.signatureText = $event.target.value;
      let matches = this.cleanInput(this.signatureText) === this.cleanInput(this.name) && this.cleanInput(this.name);
      this.$emit('updated', {
        name: this.name,
        isSigned: matches,
        key: this.userKey,
        typeKey: this.typeKey,
      });
    },
    onInputChanged($event) {

    }
  }
}
</script>
